import AbsComponent from "./AbsComponent";
import AutoSuggest from '../common/AutoSuggest';
export default class SearchBox extends AbsComponent{
    constructor(_name='', _store={}, _actions={}, _router={}, _el='',_l10n={}){
        super(_name, _store, _actions, _router, _el, _l10n);

        let _apiUrl = '/ingame/api/character/search/v2/suggest.json';
        /*
        let _apiUrl = 'https://searchsuggest.plaync.com/suggest/bns/v1.0/user';
        if(/loc|opd|sb-|rc-|rc\./.test(location.host.slice(0,3))){
            _apiUrl = 'https://rc-searchsuggest.plaync.com/suggest/bns/v1.0/user';
        }

        http://rc.search.tw.ncsoft.com/openapi/suggest.jsp?site=bns&display=10&collection=bnsusersuggest&callback=suggestCallback&query=f&_=1629856942253
        https://sb-ncw-na-search.plaync.com/openapi/suggest.jsp?site=bns&display=10&collection=bnsusersuggest&callback=suggestCallback&query=f&_=1629856942253
        https://sb-nct-search.plaync.com/openapi/suggest.jsp?site=bns&display=10&collection=bnsusersuggest&callback=suggestCallback&query=f&_=1629856942253
        tw rc : http://rc.search.tw.ncsoft.com
        tw live : http://search.tw.ncsoft.com
        ncw na rc : http://qa.na-search.ncsoft.com / 
        eu rc : http://qa.eu-search.ncsoft.com
        ncw na live : http://na-search.ncsoft.com / 
        eu live : http://eu-search.ncsoft.com
        */

        if ($('html').attr('lang') === 'ko') {
            this.autoSuggest = new AutoSuggest();
            this.autoSuggest.init({
                apiUrl: _apiUrl,
                selector : '#characterAutoSuggest',
                size: 10,
                useDelbtn: true,
                submitCallback: (_q)=>{
                    this.router.goMultiParam( {query: _q, page: 1} );
                    $('.layer.recent-list').removeClass('is-active');
                }
            });
        }else{
            $("#characterAutoSuggest [data-name='suggest_input']").on('keypress', (e)=>{
                if ( e.keyCode === 13 ) { // Enter
                    console.log( 'enter', $("#characterAutoSuggest [data-name='suggest_input']").val() );
                    this.router.goMultiParam( {query: $("#characterAutoSuggest [data-name='suggest_input']").val(), page: 1} );
                    $('.layer.recent-list').removeClass('is-active');
                }
            });
        }


        let watchQuery = this.watch(this.store.getState, 'query', this.isEqual);
        this.store.subscribe( watchQuery( (newVal, oldVal, path) => this.render(newVal, oldVal, path)));

        this.render(this.store.getState().query);

        $("#autoSuggest [data-name='suggest_submit']").on('click', (e)=>{
            if ($("#autoSuggest [data-name='suggest_input']").val().trim() == '') {
                this.router.goMultiParam( {query: '', page: 1} );
            }
        });


        $("#autoSuggest [data-name='suggest_delete']").on('click', (e)=>{
            if ($("#autoSuggest [data-name='suggest_input']").val().trim() == '') {
                this.router.goMultiParam( {query: '', page: 1} );
            }
        });
    }

    render(_newVal, _oldVal, _path){
        if(this.autoSuggest) this.autoSuggest.value(_newVal);
    }

} // end of class